import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-project-modal-timelog-remove',
  templateUrl: './project-modal-timelog-remove.component.html',
  styleUrls: ['./project-modal-timelog-remove.component.css']
})
export class ProjectModalTimelogRemoveComponent implements OnInit {

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private toastr: ToastrService,
    private http: HttpClient
  ) { }

  modalName: string = 'projectModalTimelogRemove'
  timelogId: number

  clear(): void {
    this.timelogId = null
    this.ngxSmartModalService.get(this.modalName).removeData();
  }

  remove(): void {
    this.http.delete<any>("/api/timeLog/delete?id=" + this.timelogId)
      .subscribe(
        () => {
          this.toastr.success('Tidsloggen har tagits bort.');
          this.ngxSmartModalService.get(this.modalName).removeData();
          this.ngxSmartModalService.setModalData({ success: true }, this.modalName);
          this.ngxSmartModalService.close(this.modalName);
        },
        (error) => {
          this.toastr.error('Det gick inte att ta bort tidsloggen.');
        },
        () => {
          //complete
        }
      );
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.ngxSmartModalService.getModal(this.modalName).onOpen.subscribe((modal: NgxSmartModalComponent) => {
      this.timelogId = modal.getData()
    });
  }
}
